import React, {useState} from "react";
import TableComponent from "../../common/components/TableComponent";
import styled from "styled-components";
import {Row} from "simple-flexbox";
import CustomSelect from "../../common/components/CustomSelect";
import CustomInput from "../../common/components/CustomInput";
import Utility from "../../utility";
import catalogueService from "../../services/catalogue";
import {orderStatus} from "../../constants";
import {getSignedURL, uploadFileToS3} from "../../managers/awsService";
import Dropzone from "react-dropzone";
import Utils from "../../utility";
import Button from "../../common/atoms/button";

const SearchContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-top: 20px;
    font-size: 22px;
    align-items: center;
`;

const OrderImages = styled.img`
    width: 180px;
    height: 180px;
    margin: 15px 20px 15px 0 ;
    object-fit: contain;
`;
const UploadButton = styled.a`
    text-decoration: none !important;
    width: 120px;
    height: 19px;
    font-family: sans-serif !important;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.19;
    text-align: left;
    color: #1caed0;
    border: none;
    background: none;
    padding-left: 0;
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }
`;

const OrderPendingActionComponent = (props) => {
    const {orderDetails, updateOrderStatus} = props
    const [status, setStatus] = useState(orderDetails.status)
    const [description, setDescription] = useState('')

    const updateStatus = async () => {
        if (!description) {
            return Utility.apiFailureToast('Enter required info')
        }
        const updateQuery = {status}
        if (status === orderStatus.ACCEPTED_BY_ADMIN)
            updateQuery.noOfDeliveryDays = description
        else updateQuery.rejectionReason = description
        updateOrderStatus(updateQuery)
    }

    return (
        <TableComponent.SubTable cellpadding="0" cellspacing="0" style={{width: '70%', marginTop: 20}}>
            <TableComponent.TableBody>
                <TableComponent.BodyRow>
                    <TableComponent.BodyColumn> Update Order Status -</TableComponent.BodyColumn>
                    <TableComponent.BodyColumn>
                        <CustomSelect
                            options={[orderDetails.status, orderStatus.ACCEPTED_BY_ADMIN, orderStatus.REJECTED_BY_ADMIN]}
                            onSelect={(e) => setStatus(e.target.value)}
                        />
                    </TableComponent.BodyColumn>
                </TableComponent.BodyRow>
                {status !== 'PENDING' &&
                    <TableComponent.BodyRow>
                        <TableComponent.BodyColumn>{status === orderStatus.ACCEPTED_BY_ADMIN ? 'Enter estimated days of delivery' : 'Enter the reason of rejection'}</TableComponent.BodyColumn>
                        <TableComponent.BodyColumn>
                            <CustomInput type={status === orderStatus.ACCEPTED_BY_ADMIN ? 'number' : 'text'}
                                         onChange={(e) => setDescription(e.target.value)}/>
                        </TableComponent.BodyColumn>
                    </TableComponent.BodyRow>}
                {status !== 'PENDING' && <div onClick={() => updateStatus()}
                                              className="p-1 fs-20 bg-theme fc-white display-flex justify-content-center br-4 my-1"
                                              style={{width: "inherit"}}>
                    Update Order Status
                </div>}
            </TableComponent.TableBody>
        </TableComponent.SubTable>
    )
}

const SingleButtonUpdates = (props) => {
    const {orderDetails, updateOrderStatus} = props
    const [status, setStatus] = useState(orderDetails.status)

    const updateStatus = async () => {
        const updateQuery = {status}
        updateOrderStatus(updateQuery)
    }

    return (
        <TableComponent.SubTable cellpadding="0" cellspacing="0" style={{width: '70%', marginTop: 20}}>
            <TableComponent.TableBody>
                <TableComponent.BodyRow>
                    <TableComponent.BodyColumn> Update Order Status -</TableComponent.BodyColumn>
                    <TableComponent.BodyColumn>
                        <CustomSelect
                            options={[orderDetails.status, props.nextStatus]}
                            onSelect={(e) => setStatus(e.target.value)}
                        />
                    </TableComponent.BodyColumn>
                </TableComponent.BodyRow>
                {orderDetails.status === orderStatus.PRODUCT_REJECTED_BY_USER && <TableComponent.BodyRow>
                    <TableComponent.BodyColumn>Product was rejected</TableComponent.BodyColumn>
                    <TableComponent.BodyColumn>
                        Communicate over whatsapp and rework
                    </TableComponent.BodyColumn>
                </TableComponent.BodyRow>}
                {status !== 'PENDING' && <div onClick={() => updateStatus()}
                                              className="p-1 fs-20 bg-theme fc-white display-flex justify-content-center br-4 my-1"
                                              style={{width: "inherit"}}>
                    Update Order Status
                </div>}
            </TableComponent.TableBody>
        </TableComponent.SubTable>
    )
}

const OrderAcceptedByUserActionComponent = (props) => {
    const {orderDetails, updateOrderStatus} = props
    const [status, setStatus] = useState(orderDetails.status)
    const [weight, setWeight] = useState(orderDetails.weight)
    const [preparedMedia, setPreparedMedia] = useState([]);

    const updateStatus = async () => {
        if (!preparedMedia || !preparedMedia.length) {
            return Utility.apiFailureToast('Enter required info')
        }
        const updateQuery = {status, weight, developedMedia: preparedMedia}
        updateOrderStatus(updateQuery)
    }

    const onFileDrop = async (files) => {
        if (!files || files.length < 1) {
            Utils.apiFailureToast("Unable to find Media");
            return;
        }
        let file = files[0];
        let fileDetail = Utils.getFileName(file.name);
        let companyLogo = Utils.getNewFileName("category", fileDetail.extension);
        let resFromS3 = await uploadFileToS3(file, companyLogo, file.type).catch(
            (err) => {
                Utils.apiFailureToast("Unable to upload media");
                return false;
            },
        );
        let logoURL = await getSignedURL(companyLogo);
        if (!resFromS3 || !logoURL) {
            Utils.apiFailureToast("Unable to upload media");
            return false;
        }
        const array = preparedMedia.slice();
        array.push(companyLogo)
        setPreparedMedia(array);
    };

    const acceptanceString = ".jpg, .jpeg, .png, .svg";

    return (
        <TableComponent.SubTable cellpadding="0" cellspacing="0" style={{width: '70%', marginTop: 20}}>
            <TableComponent.TableBody>
                <TableComponent.BodyRow>
                    <TableComponent.BodyColumn> Update Order Status </TableComponent.BodyColumn>
                    <TableComponent.BodyColumn>
                        <CustomSelect
                            options={[orderDetails.status, orderStatus.ORDER_PREPARED]}
                            onSelect={(e) => setStatus(e.target.value)}
                        />
                    </TableComponent.BodyColumn>
                </TableComponent.BodyRow>
                {status === 'ORDER_PREPARED' ? <>
                    <TableComponent.BodyRow>
                        <TableComponent.BodyColumn>Enter weight of developed product</TableComponent.BodyColumn>
                        <TableComponent.BodyColumn>
                            <CustomInput type="number" value={weight} onChange={(e) => setWeight(e.target.value)}/>
                        </TableComponent.BodyColumn>
                    </TableComponent.BodyRow>
                    <TableComponent.BodyRow>
                        <TableComponent.BodyColumn> Add Photo</TableComponent.BodyColumn>
                        <TableComponent.BodyColumn>
                            <Dropzone
                                multiple={false}
                                accept={acceptanceString}
                                onDrop={(files) => {
                                    onFileDrop(files);
                                }}
                                noClick={true}
                            >
                                {({getRootProps, getInputProps, open}) => (
                                    <div {...getRootProps()} className="outline-none">
                                        <input {...getInputProps()} />
                                        <UploadButton onClick={() => open()}>
                                            Add Photo
                                        </UploadButton>
                                    </div>
                                )}
                            </Dropzone>
                        </TableComponent.BodyColumn>
                    </TableComponent.BodyRow></> : ""}
                {status === 'ORDER_PREPARED' && <div onClick={() => updateStatus()}
                                                     className="p-1 fs-20 bg-theme fc-white display-flex justify-content-center br-4 my-1"
                                                     style={{width: "inherit"}}>
                    Update Order Status
                </div>}
                {preparedMedia?.length > 0 && <>
                    <SearchContainer>Developed Product</SearchContainer>
                    <Row>
                        {preparedMedia?.map((imageObj) => <OrderImages src={getSignedURL(imageObj)}/>)}
                    </Row>
                </>}
            </TableComponent.TableBody>
        </TableComponent.SubTable>
    )
}

const ActionComponent = (props) => {
    const {orderDetails, refreshOrderInfo} = props

    const updateOrderStatus = async (updateQuery) => {
        await Utility.parseResponse(catalogueService.updateOrder({
            orderId: orderDetails._id,
            updateQuery
        }));
        refreshOrderInfo()
    }
    switch (orderDetails.status) {
        case orderStatus.PENDING:
            return <OrderPendingActionComponent updateOrderStatus={updateOrderStatus} orderDetails={orderDetails}/>
        case orderStatus.ACCEPTED_BY_ADMIN:
            return ''
        case orderStatus.REJECTED_BY_ADMIN:
            return ''
        case orderStatus.ACCEPTED_BY_USER:
            return <OrderAcceptedByUserActionComponent updateOrderStatus={updateOrderStatus}
                                                       orderDetails={orderDetails}/>
        case orderStatus.REJECTED_BY_USER:
            return ''
        case orderStatus.PRODUCT_APPROVED_BY_USER:
            return <SingleButtonUpdates updateOrderStatus={updateOrderStatus} nextStatus={orderStatus.ORDER_DISPATCHED}
                                        orderDetails={orderDetails}/>
        case orderStatus.PRODUCT_REJECTED_BY_USER:
            return <SingleButtonUpdates updateOrderStatus={updateOrderStatus} nextStatus={orderStatus.ORDER_PREPARED}
                                        orderDetails={orderDetails}/>
        case orderStatus.ORDER_DISPATCHED:
            return <SingleButtonUpdates updateOrderStatus={updateOrderStatus} nextStatus={orderStatus.ORDER_DELIVERED}
                                        orderDetails={orderDetails}/>
        default:
            return ''
    }
}

function OrderDetailComponent(props) {
    const {orderDetails} = props;
    const [orderInfo, setOrder] = useState(orderDetails)

    const refreshOrderInfo = async () => {
        let [err, res] = await Utility.parseResponse(catalogueService.getCatalogue(orderDetails._id));
        console.log('refreshOrderInfo->', err)
        setOrder(res)
    }

    const onMarkReadyClicked = async () => {
        let [err, res] = await Utility.parseResponse(catalogueService.updateCatalogue({
            id: orderDetails._id,
            status: 'PUBLISHED',
            isARSupported: true,
        }));
        Utils.apiSuccessToast("Catalogue item published successfully.");
        refreshOrderInfo()
    }
    const handleDownload = (imageUrl) => {
        if (!imageUrl) return;
        const a = document.createElement('a');
        a.href = imageUrl;
        a.target = "_blank";
        a.download = imageUrl.split('/').pop(); // This will set the file name as the image's name
        a.click();
    };
    return (
        <>
            <TableComponent.SubTable cellpadding="0" cellspacing="0" style={{width: '70%', marginTop: 20}}>
                <TableComponent.TableBody>
                    <TableComponent.BodyRow>
                        <TableComponent.BodyColumn>Catalogue ID</TableComponent.BodyColumn>
                        <TableComponent.BodyColumn>{orderInfo?._id}</TableComponent.BodyColumn>
                    </TableComponent.BodyRow>
                    <TableComponent.BodyRow>
                        <TableComponent.BodyColumn>Added On</TableComponent.BodyColumn>
                        <TableComponent.BodyColumn>{new Date(orderInfo?.addedOn).toDateString()}</TableComponent.BodyColumn>
                    </TableComponent.BodyRow>
                    <TableComponent.BodyRow>
                        <TableComponent.BodyColumn>Current Status</TableComponent.BodyColumn>
                        <TableComponent.BodyColumn>{orderInfo?.isARSupported ? 'Published ✅' : '~In Process ⚙️'}</TableComponent.BodyColumn>
                    </TableComponent.BodyRow>
                    {orderInfo?.status !== 'PUBLISHED' && <TableComponent.BodyRow>
                        <TableComponent.BodyColumn>Pixelcut - RemoveBG</TableComponent.BodyColumn>
                        <TableComponent.BodyColumn>
                            {orderInfo?.removeBGURL ? "Available ✅" : 'Not yet available ⚠️'}
                        </TableComponent.BodyColumn>
                    </TableComponent.BodyRow>}
                    {(orderInfo?.status === '' || orderInfo?.status === 'DRAFT') &&
                        <TableComponent.BodyRow>
                            <TableComponent.BodyColumn>Uploaded BGRemoved Photo to MirrAR?</TableComponent.BodyColumn>
                            <TableComponent.BodyColumn>
                                <Button onClick={onMarkReadyClicked}>Mark it as Ready for use</Button>
                            </TableComponent.BodyColumn>
                        </TableComponent.BodyRow>}
                </TableComponent.TableBody>
            </TableComponent.SubTable>

            {orderInfo?.developedMedia?.length > 0 && <>
                <SearchContainer>Developed Product</SearchContainer>
                <Row>
                    {orderInfo?.developedMedia?.map((imageObj) => <OrderImages src={getSignedURL(imageObj)}/>)}
                </Row>

            </>}
            <SearchContainer>{orderInfo?.requestedMedia?.length ? "Order Images" : "Product Info"}</SearchContainer>
            <Row>
                {orderInfo?.requestedMedia?.length ? orderInfo?.requestedMedia?.map((imageObj) => <OrderImages
                        src={getSignedURL(imageObj)}/>) :
                    <TableComponent.SubTable cellpadding="0" cellspacing="0" style={{width: '70%', marginTop: 20}}>
                        <TableComponent.TableBody>
                            <TableComponent.BodyRow>
                                <TableComponent.BodyColumn>Name</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{orderInfo?.name}</TableComponent.BodyColumn>
                            </TableComponent.BodyRow>
                            <TableComponent.BodyRow>
                                <TableComponent.BodyColumn>Category</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{orderInfo?.category?.name}</TableComponent.BodyColumn>
                            </TableComponent.BodyRow>
                            {/*<TableComponent.BodyRow>*/}
                            {/*    <TableComponent.BodyColumn>Purity</TableComponent.BodyColumn>*/}
                            {/*    <TableComponent.BodyColumn>{orderInfo?.product?.purity}</TableComponent.BodyColumn>*/}
                            {/*</TableComponent.BodyRow>*/}
                            <TableComponent.BodyRow>
                                <TableComponent.BodyColumn>Product Id</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{orderInfo?._id}</TableComponent.BodyColumn>
                            </TableComponent.BodyRow>
                            <TableComponent.BodyRow>
                                <TableComponent.BodyColumn>User uploaded Image</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>
                                    {orderInfo?.media ? <div style={{}}>
                                        <OrderImages
                                            src={Utility.getMediaURL(orderInfo.media)}/>
                                        <Button onClick={() => handleDownload(Utility.getMediaURL(orderInfo.media))}>Download</Button>
                                    </div> : 'Not available ⚠️'}
                                </TableComponent.BodyColumn>
                            </TableComponent.BodyRow>
                            <TableComponent.BodyRow>
                                <TableComponent.BodyColumn>Pixelcut - RemoveBG</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>
                                    {orderInfo?.removeBGURL ? <div style={{}}>
                                        <OrderImages
                                            src={orderInfo?.removeBGURL}/>
                                        <Button onClick={() => handleDownload(orderInfo?.removeBGURL)}>Download</Button>
                                    </div> : 'Not available ⚠️'}
                                </TableComponent.BodyColumn>
                            </TableComponent.BodyRow>
                        </TableComponent.TableBody>
                    </TableComponent.SubTable>}
            </Row>
            <SearchContainer>Added By Info</SearchContainer>
            <TableComponent.SubTable cellpadding="0" cellspacing="0" style={{width: '70%', marginTop: 20}}>
                <TableComponent.TableBody>
                    <TableComponent.BodyRow>
                        <TableComponent.BodyColumn>Added By</TableComponent.BodyColumn>
                        <TableComponent.BodyColumn>{orderInfo?.addedBy?.name}</TableComponent.BodyColumn>
                    </TableComponent.BodyRow>
                    <TableComponent.BodyRow>
                        <TableComponent.BodyColumn>Shop Name</TableComponent.BodyColumn>
                        <TableComponent.BodyColumn>{orderInfo?.addedBy?.shopName}</TableComponent.BodyColumn>
                    </TableComponent.BodyRow>
                    {/*<TableComponent.BodyRow>*/}
                    {/*    <TableComponent.BodyColumn>Address</TableComponent.BodyColumn>*/}
                    {/*    <TableComponent.BodyColumn>{`${orderInfo?.addedBy?.addressInfo?.address}, ${orderInfo?.addedBy?.addressInfo?.state} - ${orderInfo?.addedBy?.addressInfo?.pincode} `}</TableComponent.BodyColumn>*/}
                    {/*</TableComponent.BodyRow>*/}
                    <TableComponent.BodyRow>
                        <TableComponent.BodyColumn>Contact Number</TableComponent.BodyColumn>
                        <TableComponent.BodyColumn>{orderInfo?.addedBy?.phone}</TableComponent.BodyColumn>
                    </TableComponent.BodyRow>
                </TableComponent.TableBody>
            </TableComponent.SubTable>
        </>
    );
}

export default OrderDetailComponent;
